// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__0yqJO","container__label":"styles_container__label__0waET","skeleton-animation":"styles_skeleton-animation__LNG9Z"};